import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postNotification = async ({ recipients, serviceId, notificationType }: JsonDataItem) => {
  const { data } = await baseQuery('service-notification', {
    type: 'POST',
    body: {
      send_customer_email: Number(recipients.includes('customerEmail')),
      send_technician_email: Number(recipients.includes('technicianEmail')),
      send_technician_sms: Number(recipients.includes('technicianMobile')),
      send_customer_sms: Number(recipients.includes('customerMobile')),
      send_secondary_customer_sms: Number(recipients.includes('customerSecondaryMobile')),
      service_id: serviceId,
      notification_type: notificationType,
    },
  });

  return data;
};
